import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HelperService, HTTPService, ValidationService } from 'app/services';
import { contact, phoneTypes } from 'app/constants/customer';
import { find } from 'lodash';

@Component({
  selector: 'app-update-recipient-dialog',
  templateUrl: './update-recipient-dialog.component.html',
  styleUrls: ['./update-recipient-dialog.component.scss'],
  providers: [DialogService],
})
export class UpdateRecipientDialogComponent implements OnInit {
  isProcessing: boolean = false;
  emails: any[] = [];
  phones: any[] = [];
  customerId: string = '';
  isFleetCustomer: boolean = false;
  phoneTypes = phoneTypes;
  phoneLength: any = 5;
  emailLength: any = 5;
  showHidePhone: boolean = true;
  showHideEmail: boolean = true;
  errors = {
    emails: {},
    phones: {},
  };
  contactOnEmail: boolean = false;
  contactOnPhone: boolean = false;
  primaryEmail: string = '';
  primaryPhone: string = '';
  prefrenceType: any;
  recipients = [];
  isMarketingEnabled: boolean = false;
  isMarketingOptOutEnabled: boolean = false;
  isMFCustomer: boolean = false;

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    private validationService: ValidationService,
    private dataService: DataService,
  ) {}

  ngOnInit() {
    const { email = '', phone = '', customerId, contactOnEmail, prefrenceType, contactOnPhone, recipients = [] } = this.dynamicDialogConfig.data;

    this.customerId = customerId;
    this.isFleetCustomer = this.dynamicDialogConfig.data.isFleetCustomer;
    this.primaryEmail = email;
    this.primaryPhone = phone;
    this.recipients = recipients;
    this.contactOnEmail = contactOnEmail;
    this.contactOnPhone = contactOnPhone;
    this.prefrenceType = prefrenceType;

    this.isMarketingEnabled = this.dataService.isMarketingEnabled;
    this.isMarketingOptOutEnabled = this.dataService.isMarketingOptOutEnabled;

    this.getCustomerContacts();
    this.getCustomer(customerId);

    if (this.isMarketingOptOutEnabled) {
      const dialogCont = document.querySelector('.update-contact-dialog');

      if (dialogCont) {
        dialogCont.classList.add('marketing-opt-in');
      }
    }
  }

  getCustomer(customerId: string) {
    if (!this.customerId) return;
    this.httpService
      .getCustomer(customerId, {
        selectedField: 'isMFCustomer',
      })
      .then(
        (customer) => {
          this.isMFCustomer = customer.isMFCustomer && this.isFleetCustomer;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
  }

  getCustomerContacts() {
    if (!this.isFleetCustomer) {
      this.showHideEmail = false;
      this.showHidePhone = false;
    }
    if (!this.customerId) return;

    this.httpService.getContactInfo(this.customerId, false, { contactEntityType: 'customer' }).then(
      (contact) => {
        if (contact && contact.contactInfo && contact.contactInfo.length) {
          contact.contactInfo.forEach((contact: any) => {
            contact.isChecked = this.recipients.includes(contact.value);

            if (contact.contactType === 'email') {
              contact.contactType = { label: 'Email', value: 'email' };

              this.emails.push(contact);
              this.sortArrayByPrimary(this.emails);
              if (this.isFleetCustomer) {
                if (this.emails.length > 5) {
                  this.showHideEmail = false;
                }
              } else {
                this.showHideEmail = false;
              }
            } else {
              contact.contactType = find(this.phoneTypes, {
                value: contact.contactType,
              });

              this.phones.push(contact);
              this.sortArrayByPrimary(this.phones);
              if (this.isFleetCustomer) {
                if (this.phones.length > 5) {
                  this.showHidePhone = false;
                }
              } else {
                this.showHidePhone = false;
              }
            }
          });
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  sortArrayByPrimary(value: any): void {
    value.sort((a, b) => {
      return a.isPrimary === b.isPrimary ? 0 : a.isPrimary ? -1 : 1;
    });
  }

  handleMultiChange(type: string, key: string, index: number, value: any) {
    this[type][index][key] = value;

    if (key === 'isActive' && !value) {
      this[type][index].isChecked = value;
    } else if (value && type === 'phones' && key === 'contactType') {
      if (value.value === 'landline') {
        this.phones[index].isPrimary = false;
        this.phones[index].isChecked = false;
      }

      if (!this.phones.filter(({ isPrimary }) => isPrimary).length) {
        for (let i = 0; i < this.phones.length; i++) {
          const { value, contactType, isActive } = this.phones[i];

          if (value && contactType && contactType.value === 'mobile' && isActive) {
            this.phones[i].isPrimary = true;
            break;
          }
        }
      }
    } else if (key === 'isPrimary') {
      this[type].forEach((contact: any, i: number) => {
        if (index !== i) {
          this[type][i].isPrimary = false;
        }
      });
    }
  }

  seeMore(type: string) {
    if (type === 'phone') {
      this.phoneLength = this.phones.length;
      this.showHidePhone = true;
    }
    if (type === 'email') {
      this.emailLength = this.emails.length;
      this.showHideEmail = true;
    }
  }

  handleAddAnother(type: string) {
    if (!this.isMFCustomer && this.isFleetCustomer) {
      if (type === 'email') {
        // && this.emails.length < 5
        const isPrimary = !this.emails.filter(({ isPrimary }) => isPrimary).length;

        this.emails.push({
          ...this.helperService.deepCopy(contact),
          isPrimary,
          isChecked: this.contactOnEmail,
          contactType: { label: 'Email', value: 'email' },
        });
        this.emailLength = this.emails.length;
      } else if (type === 'phone') {
        //  && this.phones.length < 5
        const isPrimary = !this.phones.filter(({ isPrimary }) => isPrimary).length;

        this.phones.push({
          ...this.helperService.deepCopy(contact),
          isPrimary,
          isChecked: this.contactOnPhone,
          contactType: { label: 'Mobile', value: 'mobile' },
        });
        this.phoneLength = this.phones.length;
      }
    } else {
      if (!this.isMFCustomer) {
        if (type === 'email' && this.emails.length < 5) {
          const isPrimary = !this.emails.filter(({ isPrimary }) => isPrimary).length;

          this.emails.push({
            ...this.helperService.deepCopy(contact),
            isPrimary,
            isChecked: this.contactOnEmail,
            contactType: { label: 'Email', value: 'email' },
          });
          this.emailLength = this.emails.length;
        } else if (type === 'phone' && this.phones.length < 5) {
          //
          const isPrimary = !this.phones.filter(({ isPrimary }) => isPrimary).length;

          this.phones.push({
            ...this.helperService.deepCopy(contact),
            isPrimary,
            isChecked: this.contactOnPhone,
            contactType: { label: 'Mobile', value: 'mobile' },
          });
          this.phoneLength = this.phones.length;
        }
      }
    }
  }

  handleDeleteContact(type: string, index: string) {
    this[type].splice(index, 1);
  }

  isValid() {
    let isFormValid = true;
    this.errors = {
      emails: {},
      phones: {},
    };

    if (this.emails && this.emails.length) {
      const emails = [];
      this.emails.forEach((email: any, index: number) => {
        this.errors.emails[index] = {};

        if (emails.includes(email.value)) {
          this.errors.emails[index].value = `Add a unique email`;
          isFormValid = false;
        }

        if (email.value) {
          if (email.value && !this.validationService.validateEmail(email.value)) {
            this.errors.emails[index].value = 'Email is not valid';
            isFormValid = false;
          }

          emails.push(email.value);
        }
      });
    }

    if (this.phones && this.phones.length) {
      const phones = [];

      this.phones.forEach((phone: any, index: number) => {
        this.errors.phones[index] = {};
        phone.value = this.helperService.removePhoneFormatting(phone.value);

        if (phones.includes(phone.value)) {
          this.errors.phones[index].value = `Add a unique number`;
          isFormValid = false;
        }

        if (phone.value) {
          if ((phone.value || '').length < 10) {
            this.errors.phones[index].value = `Phone is not valid`;
            //`Cell number isn't valid (000) 000-0000`;
            isFormValid = false;
          }

          phones.push(phone.value);
        }
      });
    }

    return isFormValid;
  }

  handleClose() {
    this.dynamicDialogRef.close({ isSuccess: false });
  }

  makeContactObject() {
    let contacts = [];

    contacts = this.helperService.deepCopy([...this.emails.filter(({ value }) => value), ...this.phones.filter(({ value }) => value)]);

    contacts = contacts.map((contact: any) => {
      contact.contactType = (contact.contactType && contact.contactType.value) || '';

      if (['mobile', 'landline'].includes(contact.contactType)) {
        contact.value = this.helperService.removePhoneFormatting(contact.value);
      }

      return contact;
    });

    return contacts;
  }

  handleSave() {
    if (!this.isValid() || this.isProcessing) return;

    this.isProcessing = true;
    const contacts = this.makeContactObject();
    const checkContactMap = {};
    contacts.forEach(({ value, isChecked }) => {
      checkContactMap[value] = isChecked;
    });

    this.httpService
      .updateContacts(this.customerId, { contacts })
      .then(
        (data) => {
          //Here we are sending the only recipient in estimate component to update contactInfo
          this.dataService.sendData(
            this.dataService.typePassData('customer-for-estimate', {
              contact: data.contact,
            }),
          );

          this.dynamicDialogRef.close({
            isSuccess: true,
            data: {
              ...data,
              contacts:
                (data.contact &&
                  data.contact.contactInfo.map((c: any) => ({
                    ...c,
                    isChecked: checkContactMap[c.value],
                  }))) ||
                [],
            },
          });
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isProcessing = false;
      });
  }

  handleTooltipClass(type: string = '') {
    const phone = this.phones.find((phone) => phone.isPrimary && this.helperService.removePhoneFormatting(phone.value));
    const email = this.emails.find((email) => email.isPrimary && email.value);
    if ((type === 'phone' && !phone) || (type === 'email' && !email)) {
      return `fal fa-exclamation-triangle font-13 warning-800 font-500 ml-1`;
    }
  }
}
